(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-circles"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-orris-circles]').forEach(function (f) {
      if (f.dataset.ready === '1') return;
      f.dataset.ready = '1';
      var rail = f.querySelector('[data-ocr-rail]');
      var prev = f.querySelector('[data-ocr-prev]');
      var next = f.querySelector('[data-ocr-next]');
      if (!rail) return;
      function step() {
        var el = rail.firstElementChild;
        if (!el) return rail.clientWidth;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return el.getBoundingClientRect().width + gap;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 1;
        if (prev) prev.disabled = rail.scrollLeft <= 0;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
      var t = null;
      rail.addEventListener('scroll', function () {
        if (t) return;
        t = requestAnimationFrame(function () { t = null; sync(); });
      });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-contact"] && !Shopify.designMode) return;
  try {
    
/* Open / closed for the contact page. Real local time in the shop's zone,
   because a shopper deciding whether to message now is the whole point. */
(function () {
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function openSet(key) {
    if (key === 'everyday') return [0, 1, 2, 3, 4, 5, 6];
    if (key === 'mon-fri') return [1, 2, 3, 4, 5];
    if (key === 'sat-thu') return [1, 2, 3, 4, 6, 0];
    return [1, 2, 3, 4, 5, 6];
  }

  function clock(tz) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: tz, hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit'
      }).formatToParts(new Date());
      var out = {};
      parts.forEach(function (p) { out[p.type] = p.value; });
      var day = DAYS.indexOf(out.weekday);
      if (day < 0) return null;
      return { day: day, hour: parseInt(out.hour, 10) % 24, minute: parseInt(out.minute, 10) || 0 };
    } catch (e) { return null; }
  }

  function pretty(h) {
    var suffix = h >= 12 ? 'pm' : 'am';
    var n = h % 12;
    if (n === 0) n = 12;
    return n + suffix;
  }

  function render(el) {
    var text = el.querySelector('[data-oc-status-text]');
    if (!text) return;

    var open = parseInt(el.getAttribute('data-open-hour'), 10);
    var close = parseInt(el.getAttribute('data-close-hour'), 10);
    var days = openSet(el.getAttribute('data-open-days'));
    var now = clock(el.getAttribute('data-timezone') || 'Asia/Karachi');
    if (now === null || isNaN(open) || isNaN(close) || close <= open) return;

    var isOpen = days.indexOf(now.day) > -1 && now.hour >= open && now.hour < close;
    var state, rest;

    if (isOpen) {
      state = el.getAttribute('data-open-label') || 'Open now';
      rest = el.getAttribute('data-closed-label') || '';
      el.classList.add('is-open');
      el.classList.remove('is-shut');
      text.innerHTML = '<span class="oc-status__state">' + esc(state) + '</span>'
        + (rest ? ' <span class="oc-status__rest">' + esc(rest) + '</span>' : '');
    } else {
      var i = 0, d = now.day, whenLabel;
      if (days.indexOf(now.day) > -1 && now.hour < open) {
        whenLabel = 'today at ' + pretty(open);
      } else {
        for (i = 1; i <= 7; i++) {
          d = (now.day + i) % 7;
          if (days.indexOf(d) > -1) break;
        }
        whenLabel = (i === 1 ? 'tomorrow' : 'on ' + LONG[d]) + ' at ' + pretty(open);
      }
      el.classList.add('is-shut');
      el.classList.remove('is-open');
      text.innerHTML = '<span class="oc-status__state">Closed right now</span> '
        + '<span class="oc-status__rest">— we open ' + esc(whenLabel)
        + '. Send it anyway and it is answered in order.</span>';
    }
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-oc-status]').forEach(function (el) { render(el); });
    var flash = (root || document).querySelector('[data-oc-flash]');
    if (flash && window.location.search.indexOf('form_type=contact') > -1) {
      flash.focus();
      flash.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-footer"]) return;
  try {
    
/* ---------------------------------------------------------------------------
   Footer disclosures — enhancement only.

   The accordion itself is native <details>; nothing here is needed for it to
   work. Above 750px the columns are not disclosures and the stylesheet forces
   the panels visible, so an [open] attribute left at `false` would have
   assistive tech announce "collapsed" over content that is plainly on screen.
   This keeps the attribute honest and takes the inert summary out of the tab
   order.
   --------------------------------------------------------------------------- */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');

  function discs() {
    return document.querySelectorAll('.orris-foot--v2 .orris-foot__disc');
  }

  function sync() {
    var wide = mq.matches;
    discs().forEach(function (disc) {
      var summary = disc.querySelector('summary');
      if (!summary) return;
      if (wide) {
        disc.open = true;
        summary.setAttribute('tabindex', '-1');
      } else {
        /* Closing again is the other half of the job. The wide branch forces
           [open] on so assistive tech does not announce "collapsed" over
           columns that are plainly on screen — but leaving it on when the
           viewport narrows hands the phone an accordion that is already open,
           which is the whole 900px wall of links the accordion exists to
           avoid. Loading straight into a narrow viewport was always fine, since
           the markup ships closed; it only went wrong crossing the breakpoint
           downward, which is exactly what a rotate or a resize does. */
        disc.open = false;
        summary.removeAttribute('tabindex');
      }
    });
  }

  /* Covers the keyboard: the summary is pointer-inert above 750px but Enter on
     a focused summary would still toggle it shut. Re-opening is idempotent —
     setting `open` on an already-open element fires no further toggle. */
  function guard(event) {
    if (mq.matches && !event.currentTarget.open) event.currentTarget.open = true;
  }

  function bind() {
    discs().forEach(function (disc) {
      if (disc.dataset.orrisFootBound) return;
      disc.dataset.orrisFootBound = '1';
      disc.addEventListener('toggle', guard);
    });
    sync();
  }

  bind();
  mq.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-orris-marquee]').forEach(function (vp) {
      if (vp.dataset.ready === '1') return;
      vp.dataset.ready = '1';
      var btn = vp.querySelector('[data-orris-marquee-pause]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var paused = vp.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', String(paused));
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-popup"]) return;
  try {
    
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-orris-popup]');
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var box = root.querySelector('.opz__box');
    var key = root.dataset.storageKey || 'orris-popup';
    var days = parseInt(root.dataset.rememberDays, 10);
    if (isNaN(days)) days = 14;
    var delay = parseInt(root.dataset.delay, 10);
    if (isNaN(delay)) delay = 3;

    /* Storage can throw outright in private mode and in some embedded
       webviews, so every read and write is guarded. A popup must never be the
       thing that breaks a page. */
    function suppressed() {
      try {
        var until = window.localStorage.getItem(key);
        return until && Date.now() < parseInt(until, 10);
      } catch (e) { return false; }
    }
    function suppress() {
      try {
        window.localStorage.setItem(key, String(Date.now() + days * 864e5));
      } catch (e) { /* nothing to do */ }
    }

    var lastFocus = null;

    function close() {
      root.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      suppress();
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      /* Focus trap: without it Tab walks out of the dialog and into a page the
         user cannot see. */
      var f = box.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      root.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      var field = box.querySelector('.opz__field') || box.querySelector('button');
      if (field) field.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-orris-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    /* Someone who just subscribed is the last person who should be asked
       again, so a successful post opens the thank-you state and suppresses
       future showings. */
    if (root.querySelector('.opz__form') === null && root.querySelector('.opz__btn')) {
      open();
      suppress();
      return;
    }

    if (suppressed()) return;
    if (window.Shopify && window.Shopify.designMode) { open(); return; }
    setTimeout(open, delay * 1000);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-readmore"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-orris-readmore]').forEach(function (box) {
      if (box.dataset.ready === '1') return;
      box.dataset.ready = '1';
      var text = box.querySelector('[data-orris-readmore-text]');
      var btn = box.querySelector('[data-orris-readmore-btn]');
      if (!text || !btn) return;

      /* Only clamp if the copy is actually longer than the clamp — otherwise
         the button would collapse text that already fits. */
      box.classList.add('is-clamped');
      if (text.scrollHeight <= text.clientHeight + 2) {
        box.classList.remove('is-clamped');
        return;
      }
      btn.hidden = false;

      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        box.classList.toggle('is-clamped', !open);
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orris-shop-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  /* Tabs and the rail only. Saving and quick view moved to assets/orris.js
     when the card became shared — they belong to the card, not to this
     section, and the card is now rendered on pages this section is not on. */

  function init() {
    document.querySelectorAll('[data-orris-osc]').forEach(function (root) {
      if (root.dataset.ready === '1') return;
      root.dataset.ready = '1';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-osc-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-osc-panel]'));

      function show(i) {
        tabs.forEach(function (b) {
          var on = b.dataset.oscTab === i;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) { p.classList.toggle('is-hidden', p.dataset.oscPanel !== i); });
      }
      tabs.forEach(function (b) {
        b.addEventListener('click', function () { show(b.dataset.oscTab); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var i = tabs.indexOf(b);
          var next = e.key === 'ArrowRight' ? i + 1 : i - 1;
          if (next < 0) next = tabs.length - 1;
          if (next > tabs.length - 1) next = 0;
          tabs[next].focus(); show(tabs[next].dataset.oscTab);
        });
      });

      panels.forEach(function (panel) {
        var rail = panel.querySelector('[data-osc-rail]');
        var prev = panel.querySelector('[data-osc-prev]');
        var next = panel.querySelector('[data-osc-next]');
        if (!rail) return;
        function step() {
          var first = rail.firstElementChild;
          if (!first) return rail.clientWidth;
          var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          return first.getBoundingClientRect().width + gap;
        }
        function sync() {
          var max = rail.scrollWidth - rail.clientWidth - 1;
          if (prev) prev.disabled = rail.scrollLeft <= 0;
          if (next) next.disabled = rail.scrollLeft >= max;
        }
        if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() }); });
        if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() }); });
        var f = null;
        rail.addEventListener('scroll', function () {
          if (f) return;
          f = requestAnimationFrame(function () { f = null; sync(); });
        });
        window.addEventListener('resize', sync);
        sync();
      });

    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
